module.exports = __webpack_public_path__ + "img/icon-payment-nfc.7616c025.png";